import { Card } from "antd";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
    LabelList,
} from "recharts";
import { useTranslation } from "react-i18next";

export default function CustomerDashboard() {
    const { t } = useTranslation();
    // ================= DATA =================
    const serviceData = [
        { name: "New Hairs", Q1: 28, Q2: 9 },
        { name: "CNC", Q1: 5, Q2: 1 },
        { name: "DV khác", Q1: 2, Q2: 2 },
        { name: "TM nội khoa", Q1: 4, Q2: 0 },
        { name: "Điều trị da", Q1: 3, Q2: 0 },
        { name: "Phun xăm", Q1: 1, Q2: 0 },
        { name: "SP khác", Q1: 1, Q2: 0 },
        { name: "Căng chỉ", Q1: 1, Q2: 0 },
        { name: "Sản phẩm tóc", Q1: 1, Q2: 0 },
    ];

    const statusData = [
        { name: "Q1", paid: 20, deposit: 17, direct: 8, online: 1 },
        { name: "Q2", paid: 2, deposit: 5, direct: 3, online: 2 },
    ];

    const tableData = [
        {
            type: t('sale_online.new'),
            sources: [
                { name: "FB", value: 7 },
                { name: "HOTLINE", value: 2 },
                { name: t('report.referral').toUpperCase(), value: 1 },
            ],
        },
        {
            type: "Upsale",
            sources: [
                { name: "FB", value: 3 },
                { name: "HOTLINE", value: 1 },
            ],
        },
        {
            type: t('sale_online.renewal'),
            sources: [
                { name: "FB", value: 2 },
            ],
        },
    ];

    // ================= RENDER =================
    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
                {/* LEFT */}
                <div className="flex flex-col gap-4 h-full">
                    {/* TABLE 1 */}
                    <Card
                        title={t('sale_online.customers_to_branch')}
                        className="flex-1 min-h-[320px] dark:bg-[#1f1f1f]"
                    >
                        <div className="max-h-[320px] overflow-auto">
                            <table className="text-sm w-full text-sm table-fixed">
                                <thead className="bg-gray-100 dark:bg-[#2a2a2a] text-000000e0">
                                    <tr>
                                        <th className="p-2 border">{t('sale_online.customer_type')}</th>
                                        <th className="p-2 border">Q2</th>
                                        <th className="p-2 border">Q1</th>
                                    </tr>
                                </thead>

                                <tbody className="text-000000e0">
                                    <tr className="text-center">
                                        <td className="border p-2 text-left">{t('sale_online.old')}</td>
                                        <td className="border p-2">22</td>
                                        <td className="border p-2">1</td>
                                    </tr>
                                    <tr className="text-center">
                                        <td className="border p-2 text-left">{t('sale_online.new')}</td>
                                        <td className="border p-2">10</td>
                                        <td className="border p-2">-</td>
                                    </tr>

                                    <tr className="font-bold bg-gray-100 dark:bg-[#2a2a2a] text-center">
                                        <td className="border p-2 text-left">{t('sale_online.total')}</td>
                                        <td className="border p-2">34</td>
                                        <td className="border p-2">1</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="p-3 text-xs text-gray-500">
                            {t('sale_online.note_old_customer')}
                        </div>
                    </Card>

                    {/* TABLE 2 */}
                    <Card
                        title={t('sale_online.customers_by_service')}
                        className="flex-1 min-h-[320px] dark:bg-[#1f1f1f]"
                    >
                        <div className="max-h-[320px] overflow-auto">
                            <table className="text-sm w-full text-sm table-fixed">
                                <thead className="bg-gray-100 dark:bg-[#2a2a2a] text-000000e0">
                                    <tr>
                                        <th className="p-2 border">{t('sale_online.type')}</th>
                                        <th className="p-2 border">{t('sale_online.source')}</th>
                                        <th className="p-2 border">Q2</th>
                                    </tr>
                                </thead>

                                <tbody className="text-000000e0">
                                    {tableData.map((group, i) =>
                                        group.sources.map((src, idx) => (
                                            <tr key={`${i}-${idx}`}>
                                                {/* LOẠI (rowSpan) */}
                                                {idx === 0 && (
                                                    <td
                                                        rowSpan={group.sources.length}
                                                        className="border p-2 align-middle font-medium"
                                                    >
                                                        {group.type}
                                                    </td>
                                                )}

                                                {/* NGUỒN */}
                                                <td className="border p-2">{src.name}</td>

                                                {/* VALUE */}
                                                <td className="border p-2 text-center">
                                                    {src.value}
                                                </td>
                                            </tr>
                                        ))
                                    )}

                                    {/* TOTAL */}
                                    <tr className="font-bold bg-gray-100 dark:bg-[#2a2a2a]">
                                        <td className="border p-2" colSpan={2}>
                                            {t('sale_online.total')}
                                        </td>
                                        <td className="border p-2 text-center">
                                            {tableData.reduce(
                                                (sum, g) =>
                                                    sum +
                                                    g.sources.reduce((s, x) => s + x.value, 0),
                                                0
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Card>
                </div>

                {/* RIGHT */}
                <div className="flex flex-col gap-4 h-full">
                    {/* CHART 1 */}
                    <Card
                        title={t('sale_online.visitors_by_service_and_branch')}
                        className="flex-1 min-h-[320px] dark:bg-[#1f1f1f]"
                    >
                        <ResponsiveContainer width="100%" height={320}>
                            <BarChart
                                data={serviceData}
                                margin={{ top: 20, right: 16, left: 0, bottom: 0 }}
                            >
                                <Legend verticalAlign="top" />

                                <XAxis dataKey="name" padding={{ left: 0, right: 0 }} />
                                <YAxis
                                    width={30} // hoặc 0 nếu muốn sát hẳn
                                    axisLine={false}
                                    tickLine={false}
                                />

                                <Tooltip />

                                <Bar dataKey="Q1" fill="#2F80ED">
                                    <LabelList position="top" />
                                </Bar>

                                <Bar dataKey="Q2" fill="#F2A900">
                                    <LabelList position="top" />
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>

                    {/* CHART 2 */}
                    <Card
                        title={t('sale_online.visitors_by_branch_and_status')}
                        className="flex-1 min-h-[320px] dark:bg-[#1f1f1f]"
                    >
                        <ResponsiveContainer width="100%" height={320}>
                            <BarChart
                                data={statusData}
                                margin={{ top: 20, right: 0, left: 0, bottom: 0 }}
                            >
                                <Legend verticalAlign="top" />

                                <XAxis dataKey="name" padding={{ left: 0, right: 0 }} />
                                <YAxis
                                    width={30} // hoặc 0 nếu muốn sát hẳn
                                    axisLine={false}
                                    tickLine={false}
                                />
                                <Tooltip />

                                <Bar dataKey="paid" name={t('sale_online.paid_full')} fill="#2F80ED">
                                    <LabelList position="top" />
                                </Bar>

                                <Bar dataKey="deposit" name={t('sale_online.paid_deposit')} fill="#56CCF2">
                                    <LabelList position="top" />
                                </Bar>

                                <Bar dataKey="direct" name={t('sale_online.direct_deposit')} fill="#F2A900">
                                    <LabelList position="top" />
                                </Bar>

                                <Bar dataKey="online" name={t('sale_online.online_deposit')} fill="#BDBDBD">
                                    <LabelList position="top" />
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>
                </div>
            </div>
        </div>
    );
}